module.exports = __webpack_public_path__ + "media/images/story/top/title_qa-ac8405b516ab00f6244fa3b42061cf2f.jpg";